import { CHANGE_THEME } from '../constants/actionTypes.js';
export function theme(state = {
    theme: 'default',
    scheme: 'default',
    colorPreference: 'auto',
}, action) {
    if (action.type === CHANGE_THEME) {
        return {
            theme: action.theme,
            scheme: action.scheme,
            colorPreference: action.colorPreference,
        };
    }
    return state;
}
